import React, { useEffect, useState } from 'react';
import {
  Paper, Box, Typography, MenuItem, FormControl,
  InputLabel, Select, IconButton, Button, TextField, CircularProgress, Alert
} from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import SCIBlock from 'components/SCIBlock';
import { fetchWithAuth } from 'utils/fetchWithAuth';

function nextMonth(ym) {
  const [y, m] = ym.split('-').map(Number);
  return (m === 12)
    ? `${y+1}-01`
    : `${y}-${String(m+1).padStart(2,'0')}`;
}
function prevMonth(ym) {
  const [y, m] = ym.split('-').map(Number);
  return (m === 1)
    ? `${y-1}-12`
    : `${y}-${String(m-1).padStart(2,'0')}`;
}

function Dashboard({ selectedSCI, setSelectedSCI }) {
  const [scis, setScis] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toISOString().slice(0, 7)
  );
  const [error, setError] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;
  
  useEffect(() => {
    let ignore = false;
    setLoading(true);
    fetchWithAuth(`${API_URL}/api/scis/`)
      .then(res => res.json())
      .then(data => {
        if (ignore) return;

        if (Array.isArray(data)) {
          setScis(data);
        } else {
          setScis([]);
          setError(data.detail || "Erreur inattendue lors du chargement des SCIs");
        }

        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        setError("Erreur réseau !");
      });
    return () => {
      ignore = true;
    };
  }, [API_URL]);

  useEffect(() => {
    if (scis.length > 0 && !selectedSCI) {
      setSelectedSCI(scis[0].id);
    }
  }, [scis, selectedSCI, setSelectedSCI]);


  if (loading) return (
    <Box display="flex" justifyContent="center" alignItems="center" minHeight="30vh">
      <CircularProgress />
    </Box>
  );

  if (error) return (
    <Box sx={{ m: 4 }}>
      <Alert severity="error">Erreur : {error}</Alert>
    </Box>
  );

  return (
    <Box sx={{ p: { xs: 1, md: 4 } }}>
      <Paper elevation={3} sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 4,
        p: 2,
        mb: 4,
        background: '#fdfdfe',
        flexWrap: 'wrap'
      }}>
        <FormControl sx={{ minWidth: 170, mr: 2 }}>
          <InputLabel sx={{ fontSize: 16, fontWeight: 600 }} id="label-sci">SCI</InputLabel>
          <Select
            labelId="label-sci"
            value={selectedSCI}
            label="SCI"
            onChange={e => setSelectedSCI(e.target.value)}
            sx={{ fontSize: 16, fontWeight: 600, py: 0.7 }}
            MenuProps={{ PaperProps: { sx: { fontSize: 16, fontWeight: 500 } } }}
          >
            {scis.map(sci => (
              <MenuItem key={sci.id} value={sci.id} sx={{ fontSize: 15, fontWeight: 500 }}>
                {sci.raison_sociale}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box display="flex" alignItems="center" gap={2}>
          <Typography sx={{ fontWeight: 700, fontSize: 17 }}>
            Mois :
          </Typography>
          <IconButton
            onClick={() => setSelectedMonth(prevMonth(selectedMonth))}
            aria-label="Mois précédent"
          >
            <ArrowBackIosNewIcon fontSize="medium"/>
          </IconButton>
          <TextField
            type="month"
            size="medium"
            variant="outlined"
            value={selectedMonth}
            onChange={e => setSelectedMonth(e.target.value)}
            inputProps={{
              style: { minWidth: '110px', fontSize: 16, fontWeight: 700 }
            }}
            sx={{ width: 140, fontWeight: 700 }}
          />
          <IconButton
            onClick={() => setSelectedMonth(nextMonth(selectedMonth))}
            aria-label="Mois suivant"
          >
            <ArrowForwardIosIcon fontSize="medium"/>
          </IconButton>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setSelectedMonth(new Date().toISOString().slice(0, 7))}
            sx={{ ml: 1, fontWeight: 700, fontSize: 14 }}
          >
            Mois Courant
          </Button>
        </Box>
      </Paper>

      {selectedSCI &&
        <SCIBlock
          sciId={selectedSCI}
          selectedMonth={selectedMonth}
        />
      }
    </Box>
  );
}
export default Dashboard;